import { observer }    from 'mobx-react-lite';
import ZoneCountButton from '@/TokamapEditor/ux/ZoneCountButton';

/**
 * Zones du projet auxquelles aucun thème n'est appliqué — pendant de `PlacesWithoutShapeButton`,
 * dont il reprend la forme et le comportement.
 *
 * Les images sont exclues comme elles le sont là-bas : elles portent leur propre rendu et un thème
 * n'aurait rien à y styler, elles apparaîtraient donc à jamais dans ce compte sans qu'on puisse
 * l'apurer.
 */
const ShapesWithoutThemeButton = observer(() => (
	<ZoneCountButton
		filter={shape => shape.shapeKind !== 'image' && !shape.themeId}
		suffix={() => 'sans thème'}
	/>
));

export default ShapesWithoutThemeButton;
